var _path, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "filter-black_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4H2v2h20V4H3zm0 7H2v2h20v-2H3zm-1 7h20v2H2v-2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4V3H1v1h1zm0 2H1v1h1V6zm20 0v1h1V6h-1zm0-2h1V3h-1v1zM2 11v-1H1v1h1zm0 2H1v1h1v-1zm20 0v1h1v-1h-1zm0-2h1v-1h-1v1zM2 18v-1H1v1h1zm20 0h1v-1h-1v1zm0 2v1h1v-1h-1zM2 20H1v1h1v-1zM2 5h1V3H2v2zm1 0V4H1v1h2zm0 1V5H1v1h2zm0-1H2v2h1V5zm18 0H3v2h18V5zm1 0h-1v2h1V5zm-1 0v1h2V5h-2zm0-1v1h2V4h-2zm0 1h1V3h-1v2zM3 5h18V3H3v2zm-1 7h1v-2H2v2zm1 0v-1H1v1h2zm0 1v-1H1v1h2zm0-1H2v2h1v-2zm18 0H3v2h18v-2zm1 0h-1v2h1v-2zm-1 0v1h2v-1h-2zm0-1v1h2v-1h-2zm0 1h1v-2h-1v2zM3 12h18v-2H3v2zm0 5H2v2h1v-2zm18 0H3v2h18v-2zm1 0h-1v2h1v-2zm1 2v-1h-2v1h2zm0 1v-1h-2v1h2zm-2 1h1v-2h-1v2zM3 21h18v-2H3v2zm-1 0h1v-2H2v2zm-1-2v1h2v-1H1zm0-1v1h2v-1H1z",
    fill: "#000",
    mask: "url(#filter-black_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5a2 2 0 11-4 0 2 2 0 014 0zM9 12a2 2 0 11-4 0 2 2 0 014 0zM16 19a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
export default SvgFilterBlack;